import { MAX_LIMIT } from 'config';
import { stringify } from 'query-string';
import { entityTypeToApiType } from 'helpers/mapEntityTypes';
import getRegionBreakdown from 'helpers/getRegionBreakdown';
import getCountryIds from 'helpers/getCountryIds';

interface IDiscoveriesTrendUrl {
  countryIds?: any;
  download?: boolean;
  entityIds: string[];
  entityType: 'track' | 'artist';
  sortBy?: string;
  period: any;
  region?: string;
  compareMode?: string;
  customRegion?: string | string[];
}

export default function getDiscoveriesTrendUrl(
  args: IDiscoveriesTrendUrl
): string {
  const {
    entityType,
    entityIds,
    countryIds,
    download,
    period,
    region,
    compareMode,
    customRegion,
  } = args;

  const type = entityTypeToApiType(entityType);
  const params = stringify({
    countryIds: getCountryIds(countryIds, region, customRegion),
    download,
    period,
    limit: period === 'year' ? MAX_LIMIT : undefined,
    regionBreakdown: getRegionBreakdown(
      countryIds,
      region,
      compareMode,
      customRegion
    ),
  });

  return `/api/discoveries/trend/${type}/${entityIds}?${params}`;
}
